<app-full-layout>
    <div class="flex-container" fxLayout="row wrap" fxLayoutAlign="center center">
        <mat-card class="reset-password" fxFlex="400px" fxFlex.sm="50%" fxFlex.xs="90%">
            <mat-card-content fxLayout="row wrap" fxLayoutAlign="center">
                <mat-card-title fxFlex="0 0 100%" class="title" i18n>Change password</mat-card-title>
                <app-form-error
                    fxFlex="0 0 100%"
                    header="Password reset failed"
                    i18n-header
                    [messages]="(error | async)?.error.messages"
                ></app-form-error>

                <form [formGroup]="passwdForm" fxFlex="0 0 100%">
                    <app-academy-select
                        *ngIf="academies"
                        [academies]="academies"
                        [control]="passwdForm.get('short_name') | cast"
                    ></app-academy-select>

                    <div *ngIf="!academies" fxLayout="row wrap" fxLayoutAlign="center">
                        <mat-form-field fxFlex="0 0 100%">
                            <mat-placeholder>
                                <i class="material-icons app-input-icon">account_box</i>
                                <ng-container i18n>User name</ng-container>
                            </mat-placeholder>
                            <input matInput type="text" formControlName="username" name="username" required />
                        </mat-form-field>

                        <mat-form-field fxFlex="0 0 100%">
                            <mat-placeholder>
                                <i class="material-icons app-input-icon">lock</i>
                                <ng-container i18n>Password</ng-container>
                            </mat-placeholder>
                            <input matInput type="password" formControlName="password" name="password" required />
                        </mat-form-field>

                        <mat-form-field fxFlex="0 0 100%">
                            <mat-placeholder>
                                <i class="material-icons app-input-icon">lock</i>
                                <ng-container i18n>Password confirmation</ng-container>
                            </mat-placeholder>
                            <input
                                matInput
                                type="password"
                                formControlName="password_confirmation"
                                name="confirm"
                                required
                            />
                        </mat-form-field>
                    </div>
                </form>
            </mat-card-content>
            <mat-card-actions class="flex">
                <div class="flex-space"></div>
                <button mat-button routerLink="/guest/login" i18n>Cancel</button>
                <span class="space"></span>
                <button
                    mat-raised-button
                    color="primary"
                    type="submit"
                    (click)="onSubmit()"
                    [disabled]="!passwdForm.value.token?.length"
                    i18n
                >
                    Change password
                </button>
                <div class="flex-space"></div>
            </mat-card-actions>
        </mat-card>
    </div>
</app-full-layout>
